import { useState, useEffect } from 'react';
import { Text, Popover } from '@bigcommerce/big-design';
import { ContentCopyIcon } from '@bigcommerce/big-design-icons';

export default function CopyableText({ text, label }) {
	const [isOpen, setIsOpen] = useState(false);
	const [ref, setRef] = useState(null);

	useEffect(() => {
		let timeoutId;
		if (isOpen) {
			timeoutId = setTimeout(() => {
				setIsOpen(false);
			}, 2000);
		}
		return () => {
			clearTimeout(timeoutId);
		};
	}, [isOpen]);

	if (!text) {
		return label ? <Text>{label}: N/A</Text> : <Text>N/A</Text>;
	}

	return (
		<>
			<span
				onClick={(e) => {
					e.stopPropagation();
					navigator.clipboard.writeText(text);
					setIsOpen(true);
				}}
				ref={setRef}
				style={{ cursor: 'pointer', display: 'inline' }}
			>
				{label ? `${label}: ${text}` : text}{' '}
				<ContentCopyIcon size="medium" title="Copy" />
			</span>
			<Popover
				anchorElement={ref}
				isOpen={isOpen}
				label="Copied to clipboard"
				placement="top"
				onClose={() => setIsOpen(false)}
			>
				<Text>
					<strong>{text}</strong> copied to clipboard
				</Text>
			</Popover>
		</>
	);
}
